import { Routes } from '@angular/router';
import { ConnectionPageComponent } from './connection-page/connection-page.component';
import { AccueilPageComponent } from './accueil-page/accueil-page.component';
import { ProfilComponent } from './profil/profil.component';
import { MedecinListPageComponent } from './medecin/medecin-list-page/medecin-list-page.component';
import { PatientListPageComponent } from './patient/patient-list-page/patient-list-page.component';
import { PatientPageComponent } from './patient/patient-page/patient-page.component';
import { MessageMaintenanceListPageComponent } from './message-maintenance/message-maintenance-list-page/message-maintenance-list-page.component';
import { messageMaintenanceGuard } from './guards/message-maintenance.guard';
import { MaintenancePageComponent } from './maintenance/maintenance-page/maintenance-page.component';
import { adminGuard } from './guards/admin.guard';
import { PrescriptionFormListPageComponent } from './prescription-form/prescription-form-list-page/prescription-form-list-page.component';

export const routes: Routes = [
  {
    path: 'login',
    component: ConnectionPageComponent,
  },
  {
    path: 'patient/list',
    component: PatientListPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'medecin/:id/patient/list',
    component: PatientListPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'patient/list/:filtreEcheance',
    component: PatientListPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'medecin/:id/patient/list/:filtreEcheance',
    component: PatientListPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'patient/:id',
    component: PatientPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'medecin/list',
    component: MedecinListPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'prescription-form/list',
    component: PrescriptionFormListPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: 'message-maintenance',
    component: MessageMaintenanceListPageComponent,
    canActivate: [adminGuard, messageMaintenanceGuard],
  },
  {
    path: 'maintenance',
    component: MaintenancePageComponent,
    canActivate: [],
  },
  {
    path: 'profil/:id',
    component: ProfilComponent,
    canActivate: [messageMaintenanceGuard],
  },
  {
    path: '',
    component: AccueilPageComponent,
    canActivate: [messageMaintenanceGuard],
  },
];
